import React from 'react';
import { Loader2 } from 'lucide-react';
import RatingValue from '../common/report/RatingValue';

export default function StudentRatingCell({ entry, studentName, onRetry }) {
  if (entry.status === 'loading') {
    return <span className="inline-flex" role="status" aria-label={`${studentName} 레이팅 조회 중`}><Loader2 className="size-4 animate-spin text-gray-400" aria-hidden="true" /></span>;
  }
  if (entry.status === 'error') {
    return (
      <button
        type="button"
        className="text-[10px] text-gray-500 underline decoration-dotted underline-offset-2 focus-visible:outline-primary"
        title={`${entry.message} 눌러서 다시 조회합니다.`}
        aria-label={`${studentName} 레이팅 다시 조회: ${entry.message}`}
        onClick={(event) => { event.stopPropagation(); onRetry(); }}
      >
        조회 실패
      </button>
    );
  }
  return (
    <div className="flex flex-col items-end gap-0.5">
      <RatingValue value={entry.rating} size={16} muted={entry.exam_count === 0} />
      {entry.exam_count === 0 && <span className="text-[10px] leading-none text-gray-400">기록 없음</span>}
    </div>
  );
}
